// Component
import styled from "styled-components";
import { TextField } from "@mui/material";

// Note: Hover/focus colors are handled via sx prop in parent components
// to support dark mode theming
const CustomTextField = styled(TextField)({ 
    width: '100%',
});

export default CustomTextField;